var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5984 12.768L15.0024 5.64C15.9504 5.124 16.5984 4.14 16.5984 3C16.5984 2.20435 16.2824 1.44129 15.7198 0.87868C15.1571 0.316071 14.3941 0 13.5984 0C12.8028 0 12.0397 0.316071 11.4771 0.87868C10.9145 1.44129 10.5984 2.20435 10.5984 3C10.5984 4.14 11.2464 5.124 12.1944 5.64L13.5984 12.768ZM13.5984 1.2C14.5944 1.2 15.3984 2.004 15.3984 3C15.3984 3.996 14.5944 4.8 13.5984 4.8C12.6024 4.8 11.7984 3.996 11.7984 3C11.7984 2.004 12.6024 1.2 13.5984 1.2ZM15.6624 6.96L19.5984 5.364V16.164L13.7424 18.6L6.39844 16.164L0.398438 18.564V7.764L6.39844 5.364L11.5224 7.056L13.5984 15.816L15.6624 6.96Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.3bc6a3068c40eebab83e8f95ad19e01e.svg";
export { ForwardRef as ReactComponent };